export const getLogoTitle = (drawings) => {
  if(!drawings.length) return null
  const findDrawingWithLogo = drawings.find((d) => !!d.logo)
  if(!findDrawingWithLogo) return null
  return findDrawingWithLogo.logo
}